<div class="user-card p2 col-12">
  <div class="flex items-center">
    <div class="pr1">
      <sf-user-avatar [user]="user"></sf-user-avatar>
    </div>
    <div>
      <h4 class="m0 pb1">
        @if (user.name && !user?.lastName) {
          <span>
            {{ user.name }}
          </span>
        }
        @if (user?.firstName || user?.lastName) {
          <span>
            {{user.firstName ? user.firstName : ''}}
            {{user.lastName ? user.lastName : ''}}
          </span>
        }
        @if (!user?.firstName && !user?.lastName) {
          <span>
            {{user.email ? user.email : '⠀'}}
          </span>
        }
        @if (user.correspondingAuthor) {
          <sup>*</sup>
        }
        @if (user.currentUser) {
          <span>(you)</span>
        }
      </h4>
      <div class="flex">
        <!-- <div class="online-state"></div> -->
        @if (user.userId) {
          <small>
            @for (role of user.roles; track role) {
              <span>
                <span>
                  @switch (role) {
                    <!-- <span *ngSwitchCase="'author'"><mat-icon class="mat-16" matTooltip="Author">account_box</mat-icon></span> -->
                    @case ('Editor') {
                      <span class="pr1"><mat-icon class="mat-16 mat-icon-gray " matTooltip="Editor">check</mat-icon></span>
                    }
                    @case ('CommentOnly') {
                      <span class="pr1"><mat-icon class="mat-16 mat-icon-gray " matTooltip="Comment only">comment</mat-icon></span>
                    }
                  }
                </span>
              </span>
            }
          </small>
        }
        @if (user.type === 'group') {
          <small matTooltip="This is a group or organization" class="pr1"><mat-icon class="mat-16 mat-icon-gray">corporate_fare</mat-icon></small>
        }
        <!-- <small *ngIf="user.invitedAt" matTooltip="The author has been invited" class="pr1"><mat-icon class="mat-16 mat-icon-gray">email</mat-icon></small> -->
        @if (!user.userId && !user.invitedAt) {
          <small matTooltip="Author has has no SciFlow account" class="pr1"><mat-icon class="mat-16 mat-icon-gray">no_accounts</mat-icon></small>
        }
        @if (user.deceased) {
          <small matTooltip="Author is deceased" class="pr1">†</small>
        }
        @if (user.userId && user.emailVerified) {
          <small matTooltip="Email verified" class="pr1"><mat-icon class="mat-16 mat-icon-gray">verified_user</mat-icon></small>
        }
        @if (user.hideInPublication) {
          <small matTooltip="Author is hidden from publications" class="pr1"><mat-icon class="mat-16 mat-icon-gray">visibility_off</mat-icon></small>
        }
      </div>
    </div>
  </div>
</div>


